import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";
import { t } from "utilities/localization-utils";

interface FavoriteAPublicationButtonProps {
    onClick: () => void;
}
const CSS_CLASS_NAME = "c-favorite-a-publication-button";

const FavoriteAPublicationButton = ({
    onClick,
}: FavoriteAPublicationButtonProps) => {
    return (
        <Button
            cssClassName={CSS_CLASS_NAME}
            onClick={onClick}
            size={ButtonSizes.Large}
            style={ButtonStyles.None}>
            <Icon type={Icons.StarOutline} />
            {t("favoriteItem", { item: t("publication") })}
        </Button>
    );
};

export default FavoriteAPublicationButton;
